const uiUrls = {
  publicShow(formRecordId: number) {
    return `/form/${formRecordId}`
  },
}
const apiUrl = {
  show(formRecordId: number) {
    return `/public-api/form_records/${formRecordId}`
  },
  submitForm(formRecordId: number) {
    return `/public-api/form_records/${formRecordId}`
  },
  submitLimitedForm(formRecordId: number) {
    return `/public-api/form_records/${formRecordId}/limited`
  },
}
export const config = {
  ui: {
    urls: uiUrls,
  },
  api: {
    urls: apiUrl,
  },
}
